import { UncontrolledTooltip } from "reactstrap";
import { API_BASE_URL } from "../../api/api";
import { StatusChip } from "../common/StatusChip";

export const getProductColumns = (columnHelper, navigate, handleToggleStatus,role) => [
  columnHelper.display({
    id: "image",
    header: "Imagen",
    cell: (props) => {
      const imageUrl = props.row.original.images?.[props.row.original.mainImage] || props.row.original.images?.[0];
      const fullUrl = `${API_BASE_URL}/product/get/file/${imageUrl}`;
      return imageUrl ? (
        <img
          src={fullUrl}
          alt="Producto"
          width={60}
          height={60}
          style={{ objectFit: "cover", borderRadius: "8px" }}
        />
      ) : (
        <span>Sin imagen</span>
      );
    },
  }),

  columnHelper.accessor("title", {
    header: "Título",
  }),

  columnHelper.display({
    id: "countries_prices",
    header: "Países / Precios",
    cell: (props) => {
      const adData = props.row.original.aditionalData || [];
      if (adData.length === 0) return <span>Sin países</span>;

      return (
        <div className="d-flex flex-column gap-1">
          {adData.map((item, idx) => (
            <StatusChip key={idx} tone="neutral" sm>
              {item.country_id?.name ?? "País desconocido"} - ${item.price_local_currency.toLocaleString()}
            </StatusChip>
          ))}
        </div>
      );
    },
  }),

  columnHelper.display({
    id: "avg_usdt",
    header: "Prom. USDT",
    cell: (props) => {
      const adData = props.row.original.aditionalData || [];
      if (adData.length === 0) return "-";

      const avg = adData.reduce((sum, item) => sum + (item.price_usdt ?? 0), 0) / adData.length;
      return `${avg.toFixed(2)} USDT`;
    },
  }),

  columnHelper.display({
    id: "short_desc",
    header: "Descripción corta",
    cell: (props) => {
      const text = props.row.original.shortDescription;
      const id = `desc-tooltip-${props.row.index}`;

      if (text?.length > 20) {
        return (
          <>
            <span id={id}>{text.substring(0, 20)}...</span>
            <UncontrolledTooltip placement="top" target={id}>
              {text}
            </UncontrolledTooltip>
          </>
        );
      }

      return <span>{text}</span>;
    },
  }),

  columnHelper.display({
    id: "status",
    header: "Estado",
    cell: (props) => {
      const status = props.row.original.status;
      return <StatusChip tone={status ? "success" : "danger"}>{status ? "Activo" : "Inactivo"}</StatusChip>;
    },
  }),

  columnHelper.accessor("created_at", {
    header: "Fecha creación",
    cell: (info) => new Date(info.getValue()).toLocaleDateString(),
  }),

  columnHelper.display({
    id: "actions",
    header: "Acciones",
    cell: (props) => {
      const product = props.row.original;
      const isActive = product.status;
      const toggleClass = isActive ? "ui-icon-btn ui-icon-btn--danger" : "ui-icon-btn ui-icon-btn--accent";
      const toggleIcon = isActive ? "ri-forbid-line" : "ri-checkbox-circle-line";
      const toggleText = isActive ? "Inactivar" : "Activar";

      return (
        <div className="d-flex gap-2 justify-content-end">
          <button
            type="button"
            className="ui-icon-btn ui-icon-btn--accent"
            onClick={() => navigate(`/product/detail/${product.id}`)}
            title="Ver detalle"
          >
            <i className="ri-eye-line" />
          </button>

          <button
            type="button"
            className="ui-icon-btn"
            onClick={() => navigate(`/product/edit/${product.id}`)}
            disabled={role === "ASSISTANT"}
            title="Editar"
          >
            <i className="ri-edit-line" />
          </button>

          <button
            type="button"
            className={toggleClass}
            onClick={() => handleToggleStatus(product)}
            disabled={role === "ASSISTANT"}
            title={toggleText}
          >
            <i className={toggleIcon} />
          </button>
        </div>
      );
    },
  }),
];
